import { Form } from 'antd';
import { SimulateUseCaseInterface } from 'application/usecases/SimulateUseCase';
import { SCREEN_NAME } from 'infrastructure/config/CONSTANTS';
import { PageTitle } from 'presentation/components/PageTitle';
import Content from './components/Content';

type props = {
    simualteUseCase: SimulateUseCaseInterface;
};

const CU05202Page = ({ simualteUseCase }: props) => {
    const [form] = Form.useForm();

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
            className="CU-052-02-container"
        >
            <PageTitle title={SCREEN_NAME['CU-052-02']} />
            <section
                style={{
                    padding: '10px 0px',
                    height: '100%',
                    width: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    overflowX: 'hidden',
                }}
            >
                <Content form={form} service={simualteUseCase} />
            </section>
        </div>
    );
};

export default CU05202Page;
